<template>
  <div class="flex items-center">
    <vs-avatar
      v-if="avatar"
      :src="avatar"
      class="flex-shrink-0 mr-2"
      :size="showName ? '40px' : '30px'"
      @click="avatarClick"
    />
    <div class="vx-row w-full">
      <router-link
        v-if="route"
        :to="{ name: route, params: { id: user.id } }"
        @click.stop.prevent
        class="vx-col text-inherit hover:text-primary"
      >
        {{ user.username | persian_digits }}
      </router-link>
      <span v-if="!route" class="vx-col w-full">{{ user.username }}</span>

      <span v-if="showName" class="vx-col w-full"
        >{{ user.details.firstName }} {{ user.details.lastName }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'CellUserLink',
  props: {
    user: {
      type: Object,
      required: true
    },
    showName: {
      type: Boolean,
      default: false
    },
    route: String
  },
  data() {
    return {
      avatar: null
    }
  },
  methods: {
    avatarClick() {
      if (!this.route) return
      this.$router.push({ name: this.route, params: { id: this.user.id } })
    }
  },
  computed: {
    url() {
      return `users/view/${this.user.id}`
    }
  },
  created() {
    if (!this.user.avatar) return
    this.$store.dispatch('file/downloadFile', this.user.avatar).then(response => {
      this.avatar = response
    })
  }
}
</script>
